import React from "react";
import { CheckCircle2, Send, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ActionPopupModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  variant?: "success" | "info" | "whatsapp";
}

export const ActionPopupModal: React.FC<ActionPopupModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  variant = "success",
}) => {
  const getIcon = () => {
    switch (variant) {
      case "whatsapp":
        return (
          <Send className="w-8 h-8 text-emerald-600 dark:text-emerald-400" />
        );
      case "info":
        return <Building2 className="w-8 h-8 text-primary" />;
      default:
        return (
          <CheckCircle2 className="w-8 h-8 text-emerald-600 dark:text-emerald-400" />
        );
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[420px] text-center p-6 space-y-4">
        <div className="mx-auto w-14 h-14 bg-muted/80 rounded-full flex items-center justify-center shadow-inner">
          {getIcon()}
        </div>

        <DialogHeader className="text-center space-y-1">
          <DialogTitle className="text-xl font-bold text-center text-foreground">
            {title}
          </DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground text-center whitespace-pre-line leading-relaxed">
            {description}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="sm:justify-center pt-2">
          <Button
            onClick={onClose}
            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold"
          >
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ActionPopupModal;
